import { useMemo } from 'react';

import { formatNumberToDecimal, formatNumericValue } from '@verantos-dev/shared-utils';
import {
  type AttritionTableFormattedData,
  type CohortAttritionDetail,
} from '@verantos-dev/types-cohorts';
import { type ListResponse } from '@verantos-dev/types-common';

export const useCohortAttritionDataFormatter = (
  data: ListResponse<CohortAttritionDetail> | undefined
): AttritionTableFormattedData[] => {
  const getPercentageText = (value: number | undefined) => {
    if (!value) {
      return '';
    }

    return `(${formatNumberToDecimal(value, { upperLimit: 9.5, decimals: 1 })}%)`;
  };

  const formattedData = useMemo(
    () =>
      data?.data?.map?.((item) => {
        const subjectsRemainingPercent = getPercentageText(item.subjectsRemainingPercent);
        const subjectsExcludedPercent = getPercentageText(item.subjectsExcludedPercent);

        const formattedSubjectsRemaining = item.subjectsRemaining
          ? `${formatNumericValue(item.subjectsRemaining)} ${subjectsRemainingPercent}`
          : '';
        const formattedSubjectsExcluded = item.subjectsExcluded
          ? `${formatNumericValue(item.subjectsExcluded)} ${subjectsExcludedPercent}`
          : '';

        return {
          ...item,
          formattedSubjectsRemaining,
          formattedSubjectsExcluded,
        };
      }),
    [data?.data]
  );

  return formattedData || [];
};
